<script>
    export let payments = [];
  
    let revealedRefs = new Set();

    function derivePaymentId(p) {
      const direct = p?.id;
      if (typeof direct === 'number' && Number.isFinite(direct)) return { paymentId: direct, source: 'p.id' };
      if (typeof direct === 'string' && /^\d+$/.test(direct)) return { paymentId: Number(direct), source: 'p.id:string' };

      const rawUrl = p?.invoice_url;
      if (typeof rawUrl !== 'string' || !rawUrl) return { paymentId: null, source: 'none' };

      try {
        const u = new URL(rawUrl, window.location.origin);
        const m = (u.pathname || '').match(/\/api\/payments\/(\d+)\/invoice\/?$/);
        if (m && m[1]) return { paymentId: Number(m[1]), source: 'parsed:invoice_url' };
      } catch {
        // ignore
      }

      const m2 = rawUrl.match(/\/api\/payments\/(\d+)\/invoice\/?$/);
      if (m2 && m2[1]) return { paymentId: Number(m2[1]), source: 'parsed:invoice_url:raw' };

      return { paymentId: null, source: 'unparsed' };
    }

    function buildInvoiceOpenHref(p) {
      const derived = derivePaymentId(p);
      const paymentId = derived.paymentId ?? null;
      if (!paymentId) return p?.invoice_url ?? '#';
      // Same-origin SPA route: new tab can read localStorage JWT and fetch signed URL.
      return `${window.location.origin}${window.location.pathname}#/invoice-open/${paymentId}`;
    }
  
    function toggleRef(index) {
      revealedRefs = new Set(revealedRefs);
      if (revealedRefs.has(index)) {
        revealedRefs.delete(index);
      } else {
        revealedRefs.add(index);
      }
    }
  
    function formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString('lt-LT', {
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    function getPaymentDescription(p) {
      return p?.balance_transaction_description || p?.description || null;
    }

    function getPaymentDisplayText(p) {
      return getPaymentDescription(p) || p?.reference || '';
    }
  </script>
  
  <div class="payment-area">
    {#each payments as p, index}
      <div class="payment-row">
        <div class="content">
          <div class="left">
            {#if p.paid_from && p.paid_until}
              <!-- Online payment with date range -->
              <div class="date">
                <strong>Laikotarpis:</strong> {formatDate(p.paid_from)} - {formatDate(p.paid_until)}
              </div>
            {:else}
              <!-- Manual payment without date range -->
              <div class="date">
                <strong>Mokėjimo tipas:</strong> <span style="color: #667eea;">Banko pavedimas</span>
              </div>
            {/if}
            <div class="info">
              Mokėjimo data: {new Date(p.created_at).toLocaleDateString()}
            </div>
            <div class="teacher">
              {#if revealedRefs.has(index)}
                {getPaymentDescription(p) ? 'Aprašymas:' : (p.paid_from && p.paid_until ? 'Nuorodos kodas:' : 'Aprašymas:')} {getPaymentDisplayText(p)}
                <button class="toggle-button" on:click={() => toggleRef(index)}>Nerodyti</button>
              {:else}
                <span style="font-style: italic; color: gray;">
                  {getPaymentDescription(p) ? 'Rodyti aprašymą' : (p.paid_from && p.paid_until ? 'Rodyti nuorodos kodą' : 'Rodyti aprašymą')}
                </span>
                <button class="toggle-button" on:click={() => toggleRef(index)}>Rodyti {getPaymentDescription(p) ? 'aprašymą' : (p.paid_from && p.paid_until ? 'kodą' : 'aprašymą')}</button>
              {/if}
            </div>
          </div>
  
          <div class="right">
            €{p.amount}
          </div>
        </div>
  
        {#if p.invoice_url}
          <div class="invoice-link">
            <a
              href={buildInvoiceOpenHref(p)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Žiūrėti sąskaitą
            </a>
          </div>
        {/if}
      </div>
    {/each}
  </div>
  
  <style>
    .payment-area {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      width: 100%;
      margin-top: 2rem;
    }
  
    .payment-row {
      padding: 0.75rem 1rem;
      border: 1px solid #ddd;
      border-radius: 8px;
      background-color: #fdfdfd;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
    }
  
    .left {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }
  
    .date {
      font-weight: 600;
      font-size: 0.95rem;
    }
  
    .info {
      font-size: 0.9rem;
    }
  
    .teacher {
      font-size: 0.85rem;
      color: #555;
    }
  
    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 1.2rem;
      font-weight: bold;
      white-space: nowrap;
      min-width: 60px;
    }
  
    .toggle-button {
      margin-top: 4px;
      background: none;
      border: none;
      color: #14695b;
      font-size: 0.85rem;
      cursor: pointer;
      text-decoration: underline;
      padding: 0;
      font-weight: bold;
    }
    .toggle-button:hover {
      color: #0d4c3c;
    }
  
    .invoice-link {
      margin-top: 0.5rem;
      text-align: right;
    }
    .invoice-link a {
      font-size: 0.9rem;
      color: #14695b;
      text-decoration: underline;
    }
    .invoice-link a:hover {
      color: #0d4c3c;
    }
  </style>
  